$(document).ready(function(){
    if(keyword){
        $("#faq_search").val(keyword)
    }
    $("#faq_search").on('keypress',function(e) {
        var keyword = $("#faq_search").val()
        if(e.which == 13 && keyword) {
            window.location.href="/faq?keyword="+encodeURIComponent(keyword)
        }
    });
});